<template>
  <div class="dash">
    <div class="dash__tiles">
      <StatTile tone="danger" label="Zastoj · 30+ dana" :value="fmt(d.stale.zastoj)"
        :meta="'od ' + fmt(d.stale.otvoreno) + ' mojih otvorenih'" />
      <StatTile tone="warn" label="Bez pomaka 14–30 d" :value="fmt(d.stale.uskoro)" meta="uskoro postaju zastoj" />
      <StatTile label="Novi ove sedmice" :value="fmt(d.novi_7d)" meta="predmeti koje sam zaprimio" />
      <StatTile label="Bez obaveze" :value="fmt(d.nepotpuni.bez_obaveze)" meta="nedostaje obveznik" />
    </div>

    <div class="dash__body">
      <CaseList
        class="dash__main"
        title="Traži pažnju"
        subtitle="moji otvoreni predmeti, najduže bez pomaka prvo"
        :rows="d.lista"
        :footer="fmt(d.stale.zastoj) + ' u zastoju · prikazano ' + d.lista.length"
        empty-text="Nema otvorenih predmeta"
      />

      <aside class="dash__rail">
        <section class="card">
          <h2 class="card__title">Moji predmeti po fazi</h2>
          <div class="card__hint">crveno = broj u zastoju</div>
          <div class="phases">
            <div v-for="p in d.stale.po_fazi" :key="p.status" class="phase">
              <span class="phase__dot" :style="{ background: color(p.status) }"></span>
              <span class="phase__name">{{ label(p.status) }}</span>
              <strong class="phase__count">{{ p.ukupno }}</strong>
              <span class="phase__stale">{{ p.zastoj ? p.zastoj : "" }}</span>
            </div>
          </div>
        </section>

        <section class="card">
          <h2 class="card__title">Prijem — zadnjih 8 sedmica</h2>
          <div class="spark">
            <div v-for="(w, i) in d.po_sedmicama" :key="i" class="spark__bar"
              :style="{ height: barH(w.broj) + '%' }" :title="w.broj + ' predmeta'"></div>
          </div>
          <div class="card__hint">ukupno {{ fmt(weekTotal) }} u 8 sedmica</div>
        </section>
      </aside>
    </div>
  </div>
</template>

<script>
import StatTile from "./StatTile";
import CaseList from "./CaseList";
import { getStatus, getStatusLabel } from "@/models/status";

export default {
  name: "IntakeDash",
  components: { StatTile, CaseList },
  props: { data: { type: Object, required: true } },
  computed: {
    d() {
      return this.data;
    },
    weekTotal() {
      return (this.d.po_sedmicama || []).reduce((a, w) => a + w.broj, 0);
    },
    weekMax() {
      return Math.max.apply(null, (this.d.po_sedmicama || []).map((w) => w.broj).concat([1]));
    },
  },
  methods: {
    fmt(v) {
      return String(Math.round(Number(v) || 0)).replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    label: getStatusLabel,
    color(id) {
      return getStatus(id).dot;
    },
    barH(v) {
      return Math.max((v / this.weekMax) * 100, 4);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./dash.scss";
</style>
